import * as types from "./mutation-type";

export default {
    [types.SET_FORM](state, payload) {
        state.form = payload;
    },
    [types.SET_RESET_MODAL](state, payload) {
        state.reset_modal = payload;
    },
    [types.SET_PRODUCT](state, payload) {
        state.product = payload;
    }
};
